/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

import type { ReactNode } from 'react';

export function deriveText(child: ReactNode): ReactNode {
    if (React.isValidElement(child)) {
        return React.Children.map(child.props.children, deriveText);
    }

    if (Array.isArray(child)) {
        return child.map(deriveText);
    }

    return child;
}
